import React from 'react';

import RightArrow from '../../Icons/icons/RightArrow';
import AvatarComponent from '../AvatarComponent/AvatarComponent';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import { timeAgo } from '@/utils/ts/stringUtils';

const LogPostNotification = ({ notification, handleNavigate }) => {
  return (
    <div className="log-post-notification-container">
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={notification?.influencerId?.profile_pic}
          alt={notification?.influencerId?.name || notification?.influencerId?.user_name}
        />
      </div>
      <div className="right-container">
        <div className="title">{notification?.title}</div>
        <div>
          <ButtonComponent
            onClick={() => {
              handleNavigate();
            }}
            textStyle={{fontSize:"14px"}}
            variant='text-highlight'
            style={{padding:"0px"}}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            Check it Out
          </ButtonComponent>
        </div>
        <p className="timestamp">
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
};

export default LogPostNotification;
